import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {BriefResultService} from "../../search/briefResult/briefResult.service";
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {JwtUtilService} from "../../security/jwtUtil.service";
import {StorageUtil} from "../../infra/storageUtil.service";
import {UserSessionManagerService} from "../../security/userSessionManager.service";
import {FavoritesService} from "../favorites.service";
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {MediaQueries} from "../../infra/mediaQueries.service";
import { getBxEnable, getSyndeticUnboundEnable } from '../../appConfig/appConfigForward';
import { FavoritesWarningMessageService } from '../favoritesWarningMessage/favoritesWarningMessage.service';
import { ICDCollectionObject } from '../../collectionDiscovery/collectionDiscovery.service';

const indexOf = require('lodash/indexOf');
const includes= require('lodash/includes');
const remove = require('lodash/remove');

@Component({
    selector: 'prm-save-to-favorites-button',
    templateUrl: 'components/favorites/saveToFavoritesButton/save-to-favorites-button.html',
})

export class PrmSaveToFavoritesButton implements OnInit {
    @Input() private item: PrimoResponse.IDoc;
    @Input() private isFavorites: boolean;
    @Input() private index: number;
    @Input() private isCollectionDiscovery: boolean;
    @Input() isOverlayFullView: boolean;
    @Input() private collection: ICDCollectionObject;
    private isFullView: boolean = false;
    private addFavPinStatus: string;
    private removeFavPinStatus: string;

    /*In cases where we don't have the pnx to start with and we want to get it lazily when we click the pin Icon. Supply these two parameters to the directive:
    * recordId: A string representing the record id of the record we wish to save to favorites.
    * getRecordFunction: A function which receives the record id as an argument and returns a promise which should be resolved with the record we wish to save to favorites. */
    @Input() private recordid: string;
    @Input() private getRecordFunction: (string) => Promise<PrimoResponse.IDoc>;

    private savingInProgress: boolean;

    constructor(private favoritesService: FavoritesService,
                private briefResultService: BriefResultService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                private userSessionManagerService: UserSessionManagerService,
		                private favoritesWarningMessageService: FavoritesWarningMessageService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('featuredActionsIcons') private actionsIcons,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$compile') private $compile: ng.ICompileService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$element') private $element: JQuery,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                private primolyticsService: PrimolyticsService,
                private mediaQueries: MediaQueries) {
    }

    ngOnInit() {
    }

    get recordId() {
        return this.item ? this.item.pnx.control.recordid[0] : this.recordid;
    }

    showPin() {
        return this.briefResultService.getShowPinForRecordId(this.recordId);
    }

    showBookmark() {
        return this.briefResultService.getShowBookmark();
    }

    public isFavoritesDisabled() {
        return (!this.storageUtil.isLocalStorageAvailable) && (this.jwtUtilService.isGuest());
    }

    updateFavoritesByState($event){
        if(this.isFavoriteState()){  
            // If we are in favorites state and unpin from full view overlay we don't want warning message at all
            if(this.isOverlayFullView){    
                this.updateFavorites($event);               
            }else{ 
                /* If we are in favorites state and unpin from brief display we want to display warning message,  
                we need to check our previous pin case :
                # if we pinned from overaly full display from search state -> close previous md dialog and then show our new warning md-dialog
                #  if we pinned from brief display from search state -> call our new warning md dialog immediately */                
                if (document.querySelector('.md-dialog-container')) {
                    this.briefResultService.previousUrl = undefined;
                    this.closeDialog().then(()=> {
                        this.showUnpinWarnMsg($event);
                    });
                }else{
                    this.showUnpinWarnMsg($event);
                }              
            }
        }else{ // If we are not in favorites state
            this.updateFavorites($event);
        }
    }
    
    closeDialog = function() {
        return this.$mdDialog.cancel();
    }
    
    showUnpinWarnMsg($event){
        let _this= this;
        dialogController.$inject = ['$scope'];
        this.$mdDialog.show({
            templateUrl: 'components/favorites/favorites-unpin-confirm-dialog.html',
            parent: this.getUnpinWarnParentElement($event),
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: false,
            hasBackdrop: false,
            bindToController: true,
            locals: {classThis: this, selectTypeToPass: 'single'},
            controller: dialogController,
            controllerAs: 'ctrl'
        });
        
        function dialogController($scope, selectTypeToPass) {
            $scope.selectTypeToPass = selectTypeToPass;
            this.hide = _this.$mdDialog.hide;
            this.removeIt = ()=>{
                _this.$timeout(function (){
                    _this.updateFavorites($event);
               }, 300);
            };
        }
    }
    
    private getUnpinWarnParentElement(e){
        let parentEl= angular.element(e.target).parent();
        while(!includes(parentEl[0].classList, "in-element-dialog-parent")){
            parentEl= parentEl.parent();
        }
        return parentEl[0];
    }
    
    @beacon({'p': 'brief', 'op': 'favorites'})
    updateFavorites($event) {
        if (this.item) {
            this.performUpdate($event);
        } else { //if we don't have the record call the supplied function to get it
            this.savingInProgress = true;
            this.getRecordFunction(this.recordId).then((record) => {
                this.item = record;
                this.performUpdate($event);
                this.savingInProgress = false;
            }, (error) => {
                this.savingInProgress = false;
            });
        }
    }

    @beacon({'p': 'colldisc', 'op': 'favorites'})
    private runCollectionDiscoveryBeacon(cameFromString: string, collection?) {
        this.favoritesService.addCameFromPinToFavoritesParam(cameFromString);
    }

    private performUpdate($event) {
        let user = this.jwtUtilService.getDecodedToken().user;
        if (this.userSessionManagerService.isGuest()) {
            this.updateFavoritesForGuest(user, $event);
        } else {
            this.updateFavoritesForUser(user, $event);
        }

        if (!this.showPin()) {
            this.addFavPinStatus = this.$translate.instant('nui.aria.favorites.in');
        } else {
            this.removeFavPinStatus = this.$translate.instant('nui.aria.favorites.out');
        }
    }

    //for guests save the all pnx in the local forage
    updateFavoritesForGuest(user, $event) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;

            //this record is not in the local forage
            let index = this.isRecordInArea();
            if (index == -1) {
                this.userSessionManagerService.updateUserArea(this.item).then(() => {
                    this.doPinItem($event);
                    this.updateRecordFavoritesStatus(true);
                    this.reloadListInFavoriteStateForGuest(user)
                });
            }
            //this record is already in the local forage
            else {
                this.userSessionManagerService.removeRecordFromFavorites(index).then(() => {
                    this.updateRecordFavoritesStatus(false);
                    this.reloadListInFavoriteStateForGuest(user);
                });
            }
        });
    }

    //for users save the only the id in the local forage
    updateFavoritesForUser(user, $event) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            let index = this.isRecordInArea();
            if (index == -1) {
                this.briefResultService.addUserFavorite(this.item).then(() => {
                    this.userSessionManagerService.updateUserArea(this.recordId).then(() => {
                        this.doPinItem($event);
                        this.updateRecordFavoritesStatus(true);
                        this.reloadListInFavoriteStateForUser();
                    });
                });
            } else {
                this.briefResultService.removeUserFavorite(this.recordId).then(() => {
                    this.userSessionManagerService.removeRecordFromFavorites(index).then(() => {
                        this.updateRecordFavoritesStatus(false);
						if(this.favoritesService.searchPerformed) {
							this.favoritesService.recordsId = remove(this.favoritesService.recordsId, (n) => { return n != this.recordId;});
							this.favoritesService.totalItems = this.favoritesService.recordsId.length;
							this.favoritesService.updateLabelsFromAPI(true);
							this.favoritesService.getFirstBulkOfAllItems();
						} else {
                        	this.reloadListInFavoriteStateForUser();
						}
                    });
                });
            }
        });
    }

    isRecordInArea() {
        let ids = this.userSessionManagerService.area.map((element) => this.returnRecordIds(element));
        return indexOf(ids, this.recordId);
    }

    returnRecordIds(element) {
        if (this.userSessionManagerService.isGuest()) {
            return element.pnx.control.recordid[0];
        }
        return element;
    }

    private doPinItem($event) {
        if (this.isCollectionDiscovery) {
            let cameFromString = ((this.item.pnx.display.type).toString() === "collection") ? 'collection' : 'item';
            this.runCollectionDiscoveryBeacon(cameFromString, this.collection);
        }

        let target = angular.element($event.target);
        /*function whichElem(){
         if (target.is('.md-button')) {
         return target
         } else {
         return target.parents('.md-button')
         }
         };*/
        let elem = target.parent('md-button').parent(); //TODO

        // get favorites button position in the top header
        let destinationLoc = angular.element(document.getElementById('fixed-buttons-holder'));
        let destination = angular.element(document.getElementById('favorites-button'));
        let destX = destinationLoc.prop('offsetLeft') + this.$window.pageXOffset + 8;
        let destY = destinationLoc.prop('offsetTop') + this.$window.pageYOffset + -1;

        // get clicked pin button position
        let origin = elem[0].getBoundingClientRect();
        let origX = origin.left - 1;
        let origY = origin.top + 1 + this.$window.pageYOffset;

        // create the element to insert at the position of the clicked button
        let myElement = angular.element(
            '<div class="pinDummy" style="top:' + origY + 'px; left:' + origX + 'px">\
                <prm-icon icon-type="svg" svg-icon-set="primo-ui" icon-definition="prm_pin"></prm-icon>\
             </div>'
        );

        this.$compile(myElement)(this.$scope);

        // append the element to the DOM (body)
        angular.element(document.body).append(myElement);

        // change coordinates to that of the favorites button (will animate per CSS)
        this.$timeout(function () {
            myElement.addClass('animating');
        }, 0);

        this.$timeout(function () {
            myElement.css({
                top: destY + 'px',
                left: destX + 'px'
            });
        }, 100);

        /*  this.$timeout(function(){
         context.itemPinned = true;
         }, 200); */

        this.$timeout(function () {
            destination.addClass('animating');
        }, 600);

        //remove the element from the DOM
        this.$timeout(function () {
            myElement.remove();
        }, 2000);

        this.$timeout(function () {
            destination.removeClass('animating')
        }, 1800);

        this.favoritesWarningMessageService.showMessage();
    }

    reloadListInFavoriteStateForGuest(user) {
        if (this.isFavoriteState()) {
            this.favoritesService.unpinFromFav = true;
            this.favoritesService.getItemsFromLocalForage(user);
        }
    }

    isFavoriteState() {
        if (this.$state.current.name == STATE_NAMES.FAVORITES) {
            return true;
        }
        return false;
    }

    reloadListInFavoriteStateForUser() {
        if (this.isFavoriteState()) {
            this.favoritesService.unpinFromFav = true;
            this.favoritesService.getItemsFromServer();
        }
    }

    unpinFavorites() {
        let user = this.jwtUtilService.getDecodedToken().user;
        if (this.isGuest()) {
            this.unpinFavoritesForGuest(user);
        } else {
            this.unpinFavoritesForUser(user);
        }
    }

    unpinFavoritesForGuest(user) {

        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            let index = this.isRecordInArea();
            if (index != -1) {
                this.userSessionManagerService.removeRecordFromFavorites(index).then(() => {
                    this.updateRecordFavoritesStatus(false);
                    //have to reload again the page in order to make this record disappear
                    this.favoritesService.getItemsFromLocalForage(user);
                });
            }
        });
    }


    unpinFavoritesForUser(user) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            let index = this.isRecordInArea();
            this.briefResultService.removeUserFavorite(this.recordId).then(() => {
                this.userSessionManagerService.removeRecordFromFavorites(index).then(() => {
                    this.updateRecordFavoritesStatus(false);
                    //have to reload again the page in order to make this record disappear
                    this.favoritesService.getItemsFromServer();
                }, () => {
                    this.favoritesService.getItemsFromServer(); //even if we failed to remove from local storage refresh the items since we already removed it from database
                });
            });
        });
    }

    private updateRecordFavoritesStatus(favoriteStatus) {
        this.$scope.$applyAsync(() => {  //solves issue URM-91454. For unknown reason digest wasn't triggerd in primoVE after removing record from favorites
            this.briefResultService.saveJsonOdIdsAndPins(this.recordId, favoriteStatus);
            this.$timeout(()=> {
                this.$element[0].getElementsByTagName("button")[0].focus();
            }, 500);
        });
    }

    public isFullViweState() {
        return this.$state.current.name === STATE_NAMES.FULL_DISPLAY;
    }


    public isFavoritesWarning() {
        return this.favoritesWarningMessageService.isDisplayFavoritesWarning();
    }

    public fullViewToolTipSide() {
        if (this.isFavoritesWarning() && this.mediaQueries.gtxs && this.isOverlayFullView){
            return 'left';
        }  
        return 'bottom';
    }

    public isSUBxBar(){ //checking if bX or SU are shown in fullview
        let bxenable = getBxEnable();
        let suenable = getSyndeticUnboundEnable();
        let type = this.item.pnx.display.type[0];
        let bxdisplay=bxenable;

        if (type !== 'article') { 
            bxdisplay = false;
        }
        
        return suenable || bxdisplay;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/saveToFavoritesButton/saveToFavoritesButton.directive.ts